import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../contexts/user.context";
import { toast } from "react-toastify";
import Spinner from "../components/Spinner";
import logo from "../assets/images/logo.svg";

export default function SignUp() {
  const {
    emailPasswordSignup,
    checkingStatus,
    setCheckingStatus,
    user,
    fetchUser,
  } = useContext(UserContext);
  const navigate = useNavigate();

  const [formData, setformData] = useState({
    email: "",
    password: "",
    password_confirmation: "",
  });

  const { email, password, password_confirmation } = formData;

  const changeHandler = (e) => {
    setformData((prevData) => {
      return { ...prevData, [e.target.id]: e.target.value };
    });
  };
  const signup = async (e) => {
    e.preventDefault();
    console.log(formData);
    if (password !== password_confirmation) {
      toast.error("password and confirm password are not same!!");
      return;
    }
    try {
      const regUser = await emailPasswordSignup(email, password);
      setCheckingStatus(false);
      toast.success(
        `We have sent an email to confirm your account on ${email}`
      );
      console.log("regUser", regUser);
      navigate("/sign-in");
    } catch (error) {
      console.log(error);
      setCheckingStatus(false);
      toast.error(error?.error ?? "Something went wrong with registration.");
    }
  };
  const loadUser = async () => {
    const signedInUser = await fetchUser();
    if (signedInUser) {
      navigate("/");
    }
  };

  useEffect(() => {
    if (user) {
      navigate("/");
    } else {
      loadUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (checkingStatus) {
    return <Spinner />;
  }

  return (
    <div>
      <div className="flex flex-col items-center min-h-screen pt-6 sm:justify-center sm:pt-0 bg-gray-50">
        <div className="flex ml-4 lg:ml-0">
          <button
            onClick={() => {
              navigate("/");
            }}
          >
            <span className="sr-only">Family Tree</span>
            <img className="w-auto h-16" src={logo} alt="logo" />
          </button>
        </div>

        <div className="w-full px-6 py-4 mt-6 bg-white shadow-md sm:max-w-md sm:rounded-lg">
          <form onSubmit={signup}>
            <div className="mt-4">
              <div className="flex flex-col items-start">
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onInput={changeHandler}
                  required
                  placeholder="Email"
                  className="block w-full p-3 mb-4 border rounded border-grey-light"
                />
              </div>
            </div>
            <div className="mt-4">
              <div className="flex flex-col items-start">
                <input
                  type="password"
                  name="password"
                  id="password"
                  value={password}
                  onInput={changeHandler}
                  required
                  placeholder="Password"
                  className="block w-full p-3 mb-4 border rounded border-grey-light"
                />
              </div>
            </div>
            <div className="mt-4">
              <div className="flex flex-col items-start">
                <input
                  type="password"
                  name="password_confirmation"
                  id="password_confirmation"
                  value={password_confirmation}
                  onInput={changeHandler}
                  required
                  placeholder="Confirm Password"
                  className="block w-full p-3 mb-4 border rounded border-grey-light"
                />
              </div>
            </div>
            <div className="flex items-center justify-end mt-4">
              <button
                className="text-sm text-indigo-600 underline hover:text-indigo-900"
                onClick={() => {
                  navigate("/sign-in");
                }}
              >
                Already registered?
              </button>
              <button
                type="submit"
                className="py-3 my-1 ml-4 text-center text-white bg-indigo-600 rounded px-7 hover:bg-indigo-900 focus:outline-none"
              >
                Register
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
